/*
NOTES:
It depends on a these css settings:
.d-scroll {
    cursor: move;
    cursor: grab;
    user-select: none;
    & * {
        user-select: none;
    }
}
.d-scroll.dragging a {
    pointer-events: none;
}
 */


const dragScroll = (el) => {

    let isDown = false;
    let startX;
    let scrollLeft;
    let isDragging = false;
    let draggedItem = false;
    let speed = 1;
    if (el.classList.contains('fast')) speed = 2;
    let act = el.getAttribute('act');
    let clickFunc = act && window[act] && typeof window[act] === 'function' ? window[act] : false;

    el.addEventListener("mousedown", e => {
        isDown = true;
        startX = e.pageX - el.offsetLeft;
        scrollLeft = el.scrollLeft;
        if (e.target !== el) draggedItem = e.target; // save the item clicked on (only if it isn't the parent)
    });
    el.addEventListener("mouseleave", () => {
        isDown = false;
        el.classList.remove("dragging");
        //if (draggedItem) draggedItem.classList.remove('no-pointer-events');
        isDragging = 0;
        draggedItem = false;
    });
    el.addEventListener("mouseup", (evt) => {
        isDown = false;
        // run the click function if it exists and there is no dragging (just a click without drag)
        if (clickFunc && !isDragging) clickFunc(evt);
        //el.classList.remove("dragging");
        if (draggedItem) setTimeout(() => el.classList.remove("dragging"), 200);
        isDragging = 0;
        draggedItem = false;
    });
    el.addEventListener("mousemove", e => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - el.offsetLeft;
        const walk = x - startX;
        if (isDragging || (walk > 10 || walk < -10)) { // only kick in if the mouse moves more than 10 pixels - otherwise it could be a click
            el.scrollLeft = scrollLeft - (walk * speed);
            //if (draggedItem && !isDragging) draggedItem.classList.add('no-pointer-events'); // this is the magic sauce for canceling any click events on the mouse up
            if (draggedItem && !isDragging) el.classList.add('dragging'); // this is the magic sauce for canceling any click events on the mouse up
            isDragging = 1;
        }
    });
    // for mobile, we need to listen to touch events in case there's a click handler
    if (clickFunc && (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0))) {
        el.addEventListener("touchstart", e => {
            isDown = true;
            startX = e.touches[0].pageX - el.offsetLeft;
            scrollLeft = el.scrollLeft;
        });
        el.addEventListener("touchend", (e) => {
            isDown = false;
            if(!isDragging) clickFunc(e);
            isDragging = 0;
        });
        el.addEventListener("touchmove", e => {
            if (!isDown) return;
            const x = e.touches[0].pageX - el.offsetLeft;
            const walk = x - startX;
            if ((walk > 10 || walk < -10)) {
                isDragging = 1;
            }
        });

    }
}

// drag scroll
document.addEventListener('mousemove', () => {
    const dragScrollers = document.querySelectorAll(".d-scroll");
    if (dragScrollers && dragScrollers.length) {
        dragScrollers.forEach((i) => dragScroll(i));
    }
}, { once: true });